import { getMedianZoneCode } from '@domains/median-zones/store/slices/medianZones.slice';
import { getIntersectionListHandler, getListPolygons } from './state.selectors';
import { createSelector } from 'reselect';
import { getIntersectionsByZone } from '../utils/intersectionsByZone';
// Direct slice-path import (NOT '@domains/polygon-tool') to avoid the circular
// barrel chain: polygon-tool/index.ts re-exports EditPolygonButton which imports
// from @domains/save-polygons, and that triggers this file mid-init. Mirror del
// patrón usado en Plan 03-06 con getIsRoleIsPolygonCreator (ver STATE.md).
import { getPolygonTypeFilter } from '@domains/polygon-tool/store/slices/polygon-slice';

export const getPolygonsForCards = createSelector(
  [
    getListPolygons,
    getIntersectionListHandler,
    getMedianZoneCode,
    getPolygonTypeFilter, // Phase 5 D-13: cards reaccionan al filtro 'blocking'
  ],
  (listPolygons, intersectionListHandler, medianZoneCode, polygonTypeFilter) => {
    const intersectionSet = new Set<string>();

    intersectionListHandler.forEach(intersection => {
      intersection.polygonIds?.forEach(id => intersectionSet.add(id));
    });

    const isBlockingFilter = polygonTypeFilter === 'blocking';
    const isAllFilter = polygonTypeFilter === 'all';

    // D-13: cuando filter='blocking' no filtrar por median_zone (blockings
    // son globales). En filter='all' aceptar match de median_zone O blockings
    // del área para que las cards muestren ambos tipos.
    const filtered = isBlockingFilter
      ? listPolygons
      : listPolygons.filter(polygon => {
          const sameZone =
            polygon.median_zone_id?.toString() === medianZoneCode;
          if (isAllFilter) {
            return sameZone || polygon.polygon_type === 'blocking';
          }
          return sameZone;
        });

    return filtered.map(polygon => ({
      ...polygon,
      // D-15: forzar showDeleteButton:false para todos cuando filter='blocking'
      // (delete de blockings se posterga a v2 con UX dedicada).
      showDeleteButton: isBlockingFilter
        ? false
        : !intersectionSet.has(polygon.polygon_id),
    }));
  }
);

export const getIfAgentCanSaveIntersections = createSelector(
  [getListPolygons, getIntersectionListHandler, getMedianZoneCode],
  (listPolygons, intersectionListHandler, medianZoneCode) => {
    const filteredPolygons = listPolygons.filter(
      polygon => polygon.median_zone_id?.toString() === medianZoneCode
    );

    const intersectionsByZone = getIntersectionsByZone(
      intersectionListHandler,
      filteredPolygons
    );

    let canSave = true;
    const reasonsSet = new Set<string>();

    intersectionsByZone.forEach(intersection => {
      if (!intersection.comment) {
        canSave = false;
        reasonsSet.add(
          `No tiene comentario la intersección ${intersection.idsPolygonString}`
        );
      }
      if (!intersection.priorityPolygonId) {
        canSave = false;
        reasonsSet.add(
          `No tiene polígono prioritario la intersección ${intersection.idsPolygonString}`
        );
      }
      if ((intersection.polygonIds?.length || 0) > 2) {
        canSave = false;
        reasonsSet.add(
          `Tiene más de dos polígonos la intersección ${intersection.idsPolygonString}`
        );
      }
    });

    return {
      canSave,
      reasons: Array.from(reasonsSet),
    };
  }
);
